import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';

@withRouter
@inject("store")
@observer
export default class UserSpan extends Component
{
    // constructor(props) 
    // {
    //     super(props);
    // }
    
    // componentDidMount()
    // {
    //    // 
    // }

    // componentDidUpdate(prevProps)
    // {
    //     if (this.props.data !== prevProps.data) 
    //     {
           
    //     }
    // }
    
    render()
    {
        const user = this.props.data;
        if( !user ) return null;
        return <div className="user-span">
            <img src={user.avatar_url} className="avatar"/>
            {user.name}
            {user.coin >= 0 && <span className="coin bg-blue-500 text-white font-mono text-xs">{user.coin}</span> }
        </div>;
    }
}